import { create } from "zustand"

type ParserSearchStore = {
  searchTerm: string
  isSearchActive: boolean
  setSearchTerm: (term: string) => void
  openSearch: () => void
  closeSearch: () => void
  clearSearch: () => void
}

export const useParserSearchStore = create<ParserSearchStore>((set) => ({
  searchTerm: "",
  isSearchActive: false,

  setSearchTerm: (term) => {
    set({ searchTerm: term })
  },

  openSearch: () => {
    set({ isSearchActive: true })
  },

  closeSearch: () => {
    set({ isSearchActive: false, searchTerm: "" })
  },

  clearSearch: () => {
    set({ searchTerm: "" })
  },
}))
